import { Col, DatePicker, Row, Collapse } from "antd";
import { CDBIcon, CDBTable, CDBTableBody, CDBTableHeader } from "cdbreact";
import { Button, Container } from "react-bootstrap";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import NavBarPeiix from '../../NavBar';
const { Panel } = Collapse; // Desestructura Panel desde Collapse

const headerStyle = {
    borderTop: '1px solid #DCDCDC', // Borde superior
    borderBottom: '1px solid #DCDCDC', // Borde inferior
    backgroundColor: '#DCDCDC', // Fondo
    color: '#3E4144', // Color del texto
};
const Facturas = () => {
    return (
        <>
            <div className="Facturas">
                <NavBarPeiix />

                <div className='navbar-container' style={{ padding: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div className='navbar-imgl' style={{ flex: '0 0 auto' }}>
                        <h3 className=" fw-bold" style={{ color: '#3E3E3E', fontFamily: 'Montserrat, sans-serif', marginBottom: '0', display: 'flex', alignItems: 'center' }}>
                            <CDBIcon icon="file-alt" /> Facturas
                        </h3>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexGrow: 1 }}>
                        
                    </div>
                </div>

                <br />
                <Container fluid>
                    <p className="fw-bold" style={{ color: "#3E4144", fontSize: '20px', fontFamily: 'Montserrat, sans-serif', textAlign: 'left', paddingLeft: '40px' }}>Opciones de Filtrado</p>
                    <div className="display-5 fw-bold h1" style={{ color: "black", padding: '10px' }}>
                        <Row className='m-3 d-flex justify-content-left' gutter={[8, 16, 24, 32]}>
                            <Col className="gutter-row" xs={24} sm={12} md={6} lg={4}>
                                <DatePicker
                                    className="col-12"
                                    placeholder="Fecha Inicio"
                                    format="DD/MM/YYYY"
                                />
                            </Col>

                            <Col className="gutter-row" xs={24} sm={12} md={6} lg={4}>
                                <DatePicker
                                    className="col-12"
                                    placeholder="Fecha Fin"
                                    format="DD/MM/YYYY"

                                />
                            </Col>
                        </Row>
                    </div>
                </Container>
                <br />
                <CDBTable hover responsive maxHeight="70vh" scrollY style={{ fontSize: '16px', fontFamily: 'Montserrat, sans-serif' }}>
                    <CDBTableHeader>
                        <tr >
                            <th style={headerStyle}>Folio</th>
                            <th style={headerStyle}>Concepto</th>
                            <th style={headerStyle}>Monto</th>
                            <th style={headerStyle}>PDF</th>
                            <th style={headerStyle}>XML</th>
                        </tr>
                    </CDBTableHeader>
                    <br />
                    <CDBTableBody>
                        <tr>
                            <td>470290</td>
                            <td>Comisiones Junio del 2024</td>
                            <td>$1,059.86</td>
                            <td><Button
                                type="button"
                                style={{
                                    height: 'auto',
                                    borderRadius: '8px',
                                    border: '1px solid #0E9600', // Bordes verdes
                                    backgroundColor: '#D9FFD5', // Fondo blanco
                                    color: '#0E9600', // Letras verdes
                                }}
                            >
                                <CDBIcon icon="download" />
                            </Button></td>
                            <td><Button
                                type="button"
                                style={{
                                    height: 'auto',
                                    borderRadius: '8px',
                                    border: '1px solid #0E9600', // Bordes verdes
                                    backgroundColor: '#D9FFD5', // Fondo blanco
                                    color: '#0E9600', // Letras verdes
                                }}
                            >
                                <CDBIcon icon="download" />
                            </Button></td>
                        </tr>
                    </CDBTableBody>
                </CDBTable>
            </div>
        </>
    );
}

export default Facturas;